import React from "react";
import PropTypes from "prop-types";
import { PoweredByQgiv } from "@qgiv/core-react";
import ConnectedReceiptSocialSharing from "./ConnectedReceiptSocialSharing";
import "./ReceiptEventFooter.scss";

const ReceiptEventFooter = ({
    displaySharingOptions,
    controlId,
    receiptId,
    isSmallScreen,
}) => (
    <footer
        className={`receipt-event-footer event-footer grid 
            ${isSmallScreen ? "grid--flex-direction-column-reverse -padding-top--0" : "-padding-top--15"} 
            grid--align-items-center -padding-bottom--50 `}
    >
        <div
            className={`col ${
                displaySharingOptions === 0 ? "col--12" : "col--12 col--sm-6"
            } col--no-top-gutter`}
        >
            <PoweredByQgiv
                dark
                classNames={
                    displaySharingOptions === 0 || isSmallScreen
                        ? []
                        : ["-margin--0"]
                }
            />
        </div>
        {displaySharingOptions === 1 && (
            <div className="col col--12 col--sm-6 -text--right col--no-top-gutter">
                <ConnectedReceiptSocialSharing
                    controlId={controlId}
                    receiptId={receiptId}
                />
            </div>
        )}
    </footer>
);

ReceiptEventFooter.propTypes = {
    displaySharingOptions: PropTypes.number.isRequired,
    controlId: PropTypes.number.isRequired,
    receiptId: PropTypes.string.isRequired,
    isSmallScreen: PropTypes.bool.isRequired,
};

export default ReceiptEventFooter;
